import styled, { css } from 'styled-components';
import { theme, palette, prop } from 'styled-tools';
import { Btn } from 'components';

interface ContainerProps {
    background?: string;
}

export const FileImgContainer = styled.div<ContainerProps>`
    border-radius: 8px;
    display: flex;
    align-items: center;
    width: 100%;

    ${props => {
        if (props.background) {
            return css`
                height: 200px;
                background-size: cover;
                background-image: url('${prop('background')}');
            `;
        } else {
            return css`
                height: 60px;
                background-color: ${palette('gray_opacity_100')};
            `;
        }
    }}
`;

export const InputFileWrapper = styled.div`
    width: 120px;
    max-width: 260px;
    height: 44px;
    background-color: ${palette('gray_opacity_50')};
    border: 1px solid ${palette('gray_opacity_500')};
    box-sizing: border-box;
    border-radius: 8px;
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
`;


export const LabelWrapper = styled.div`
    margin: 0 auto;
    pointer-events: none;
    > svg {
        margin-right: 4px;
    }
`;

export const ImageCover = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background: ${palette('gray_opacity_400')};
    ${theme('commonPadding')}
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const InfoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const BtnDelete = styled(Btn)`
    width: 83px;
    height: 32px;
`;